// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-yandex-share[data-v-d2ffc23a]{-webkit-transition-duration:.3s;transition-duration:.3s}.vue-yandex-share[data-v-d2ffc23a]:empty{opacity:0}", ""]);
// Exports
module.exports = exports;
